<script lang="ts" setup>
  type Props = {
    icon?: string
    title?: string
    text?: string
  }

  const props = defineProps<Props>()
</script>

<template>
  <div class="c-static-page-card">
    <Paper>
      <div class="title">
        <SvgIcon
          :icon="props.icon ?? 'mate'"
          :height="40"
          :width="40"
        />
        <span>{{ props.title ?? 'title' }}</span>
      </div>
      <div
        v-if="props.text"
        class="text"
      >
        <span>{{ props.text }}</span>
      </div>
      <slot />
    </Paper>
  </div>
</template>
<style scoped>

.c-static-page-card {
  .c-paper {
    display: flex;
    flex-direction: column;
    padding: 2em 1em;
    border-radius: 0.5rem;
    margin: 5em 0.625em 0.625em;

    .title {
      display: flex;
      flex-direction: row;
      align-items: flex-start;

      span {
        align-self: center;
        color: var(--color-secondary);
        font-family: Bariol, sans-serif;
        font-size: 2em;
        font-weight: 700;
        line-height: 1.25em;
      }

      .c-icon {
        display: flex;
        width: 3.75rem;
        height: 3.75rem;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        margin-right: 0.625em;
        margin-bottom: auto;
        background-color: var(--color-primary);
        color: white;
        transform: translate(0, -3.875rem);
      }
    }

    .text {
      margin-top: 2rem;

      span {
        color: var(--color-secondary);
        font-family: Open-Sans, sans-serif;
        font-size: 1em;
        font-weight: 600;
      }
    }
  }

  @media screen and (width >= 1024px) {
    .c-paper {
      padding: 3em;

      .title {
        .c-icon {
          transform: translate(-1.125rem, -4.875rem);
        }
      }
    }

    .text {
      font-size: 1.125em;
      line-height: 1.5;
    }
  }
}
</style>
